import React,{useRef} from "react";
import Wrp from '../../../../hoc/Wrp/Wrp';
import Icons from "../../../../Components/Icons/Icons";
import Modal from "react-bootstrap/Modal";
import Inputs from '../../../../Components/Inputs/Inputs';
import {getUserInfo} from '../../../../Utils/UserFunctions';

const DirectoryChoosePopup = (props) => {

    const uploadMultipleFiles = useRef();

    //console.log(JSON.parse(props.formFolderFields), 'props.formFolderFields');
    //console.log(getUserInfo(), 'getUserInfo')
    const curProfileID = getUserInfo().data.profile_id;    
    let directorylists = JSON.parse(props.directoryLists);
    let folderListsHtml = '';
    folderListsHtml = directorylists.map((directory,index) => {

    });
    

    const DirectoryList = ({data}) => {
      return (
        <ul className="list-group" id="treeView">
          {data.map((d, index) => {
            let checkedVal = false;
            if(props.uploadDirectoryId === d.id){checkedVal = true}
            return (
              <li className="roles_Setup list-group-item p-1">
                <span className="mr-2">
                  <Icons iconType="Folder" />
                </span>
                <label className="form-radio-label">
                  <input checked={checkedVal} onClick={e=>props.assignDirectoryForUpload(d.id)} className="form-radio-input" type="radio" name="optionsRadios" value="" /> <span className="form-radio-sign">{d.name}</span>
                </label>              
              {d.documents && <DirectoryList data={d.documents} />}
              </li>);
          })}
        </ul>
      );
    }

    const onFileChange =()=>{                
      var inputField = uploadMultipleFiles;
      //console.log(inputField);
      inputField.current.click();
    }

    const uploadMultipleFilesHandler = (e) => {
      //let updateFiles = this.state.files;
      props.uploadFileAPICall(e.target.files);
      
    }

    return(
        <Wrp>
            <Modal dialogClassName="modal-dialog modal-dialog modal-xl height-auto" show={props.isModalDirectoryChoosePopup} onHide={props.toggleDirectoryChoosePopup}>
              <Modal.Header>
                <h5 className="modal-title secondary_color pl-2 mb-0"> Upload Files </h5> 
              </Modal.Header>
              <Modal.Body>
                <div className="row">
                  <div className="col-12">
                    <div className="card card-transparent">
                      <div className="card-header p-0">
                        <div className="card-title">
                          Choose Directory to Upload
                        </div>
                      </div>
                      <div className="card-body">
                        <DirectoryList data={directorylists} />                        
                      </div>
                    </div>
                  </div>
                </div>   
              </Modal.Body>
              <Modal.Footer>
                  <a className="btn btn-border border-default mr-2" data-dismiss="modal" onClick={e=>props.toggleDirectoryChoosePopup('Upload','')}> Cancel </a> 
                  
                  {
                    (props.uploadDirectoryId!=='')?
                      (props.uploadDirectoryType==='Upload')?
                      <a className="btn primary_bg" onClick={onFileChange}>Upload 
                      <input id="fileInput" accept="*" ref={uploadMultipleFiles} type="file" style={{display:'none'}} onChange={uploadMultipleFilesHandler} />
                      </a>
                      :
                      <a className="btn primary_bg" onClick={props.callMoveCopyHandler}>{props.uploadDirectoryType}</a>  
                   :
                   '' 
                 }
                   
                                 
              </Modal.Footer>
            </Modal>

            
        </Wrp>
    )
}

export default DirectoryChoosePopup;